import './Appointment.css';
import 'react-toastify/dist/ReactToastify.css';
import "react-datepicker/dist/react-datepicker.css";

import { toast } from 'react-toastify';
import React, { useContext, useEffect, useState } from 'react';
import DatePicker from "react-datepicker";

import doctorContext from '../../context/doctors/doctorscontext';
import appointmentContext from '../../context/appointment/appointmentcontext';
import progressContext from '../../context/loading/progresscontext';
import Breadcrumb from '../Breadcrumb/Breadcrumb';

// Default hospital doctors fallback if clinic backend is slow/offline
const defaultDoctors = [
  { doctor_id: "dr-nishita-rao", doctor_name: "Dr. Nishita Rao (MBBS, MS - Obstetrics & Gynaecology)" },
  { doctor_id: "dr-mahesh-rao", doctor_name: "Dr. Mahesh Rao (MBBS, DCH - Paediatrics & Child Care)" },
  { doctor_id: "general-consultation", doctor_name: "General Physician & Surgical Consultation" }
];

// Default slot timings fallback
const defaultSlots = [
  { slot_id: "s1", start_time: "09:30 AM", end_time: "10:00 AM", status: "0" },
  { slot_id: "s2", start_time: "10:00 AM", end_time: "10:30 AM", status: "0" },
  { slot_id: "s3", start_time: "10:30 AM", end_time: "11:00 AM", status: "0" },
  { slot_id: "s4", start_time: "11:00 AM", end_time: "11:30 AM", status: "0" },
  { slot_id: "s5", start_time: "11:30 AM", end_time: "12:00 PM", status: "0" },
  { slot_id: "s6", start_time: "04:30 PM", end_time: "05:00 PM", status: "0" },
  { slot_id: "s7", start_time: "05:00 PM", end_time: "05:30 PM", status: "0" },
  { slot_id: "s8", start_time: "05:30 PM", end_time: "06:00 PM", status: "0" },
  { slot_id: "s9", start_time: "06:00 PM", end_time: "06:30 PM", status: "0" },
  { slot_id: "s10", start_time: "06:30 PM", end_time: "07:00 PM", status: "0" },
  { slot_id: "s11", start_time: "07:00 PM", end_time: "07:30 PM", status: "0" }
];

function Appointment() {
  const [apptDate, setApptDate] = useState(new Date());
  const [selectedDoctor, setSelectedDoctor] = useState("dr-nishita-rao");
  const [selectedTime, setSelectedTime] = useState("");
  const [patientData, setPatientData] = useState({
    name: "",
    email: "",
    phone: "",
    age: "18-40",
    address: "",
    message: ""
  });

  const { setProgress } = useContext(progressContext);
  const { docList } = useContext(doctorContext);
  const { slotTimings, getSlots, saveAppointment } = useContext(appointmentContext);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (setProgress) {
      setProgress(70);
      setTimeout(() => {
        setProgress(100);
      }, 100);
    }
  }, [setProgress]);

  // Use backend docList if available, otherwise use default doctors
  const doctorsToRender = docList && docList.length > 0 ? docList : defaultDoctors;

  // Use backend slotTimings if available, otherwise default slots
  const slotsToRender = slotTimings && slotTimings.length > 0 ? slotTimings : defaultSlots;

  const checkAvailableSlots = () => {
    if (selectedDoctor && apptDate) {
      if (getSlots) {
        getSlots(selectedDoctor, apptDate);
      }
      toast.info("Checking available slots for selected date...", { theme: "colored" });
    } else {
      toast.error("Please Select a Doctor and Appointment Date!", { theme: "colored" });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPatientData(prev => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (!selectedDoctor) {
      toast.error("Please select a Doctor!", { theme: "colored" });
      return;
    }

    if (!selectedTime) {
      toast.error("Please Select Slot Timing!", { theme: "colored" });
      return;
    }

    if (!patientData.name.trim() || !patientData.phone.trim()) {
      toast.error("Please enter Patient Name and Phone Number!", { theme: "colored" });
      return;
    }

    const formattedDate = apptDate
      ? `${apptDate.getFullYear()}-${apptDate.getMonth() + 1 < 10 ? "0" + (apptDate.getMonth() + 1) : apptDate.getMonth() + 1}-${apptDate.getDate() < 10 ? "0" + apptDate.getDate() : apptDate.getDate()}`
      : "";

    // Find doctor name for clear recording
    const matchedDoc = doctorsToRender.find(d => d.doctor_id === selectedDoctor);
    const doctorDisplayName = matchedDoc ? matchedDoc.doctor_name : selectedDoctor;

    if (saveAppointment) {
      saveAppointment({
        patientName: patientData.name,
        patientEmail: patientData.email,
        patientPhone: patientData.phone,
        patientAge: patientData.age,
        patientAddress: patientData.address,
        message: patientData.message,
        drName: doctorDisplayName,
        apptDate: formattedDate,
        apptTime: selectedTime
      });
    } else {
      toast.success("Your appointment request has been submitted successfully!", { theme: "colored" });
    }

    // Reset Form
    setPatientData({
      name: "",
      email: "",
      phone: "",
      age: "18-40",
      address: "",
      message: ""
    });
    setSelectedTime("");
  };

  return (
    <main className="appointment-page">
      <Breadcrumb
        pageName="Book an Appointment"
        bgImage="/img/uplaods/rad.jpg"
        path={[
          { label: 'Home', href: '/' },
          { label: 'Book Appointment' }
        ]}
      />

      <section id="appointment" className="appointment-section">
        <div className="wrap">
          <div className="appointment-card">
            <div className="section-title">
              <p className="eyebrow">Consultation Booking</p>
              <h2>Book an Appointment</h2>
              <p className="lead-text">Book your appointment today and let our doctors help you.</p>
            </div>

            <form className="appointment-form" onSubmit={handleFormSubmit}>
              {/* Doctor & Slot Selection */}
              <div className="form-grid">
                <div className="field">
                  <label htmlFor="doctor">Select Doctor *</label>
                  <select
                    name="doctor"
                    id="doctor"
                    className="form-select"
                    value={selectedDoctor}
                    onChange={(e) => setSelectedDoctor(e.target.value)}
                    required
                  >
                    <option value="">Select Doctor</option>
                    {doctorsToRender.map((item) => (
                      <option value={item.doctor_id} key={item.doctor_id}>
                        {item.doctor_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="field">
                  <label htmlFor="appt-date">Select Appointment Date *</label>
                  <DatePicker
                    id="appt-date"
                    className="form-control"
                    placeholderText="Select Appointment Date *"
                    selected={apptDate}
                    onChange={(date) => setApptDate(date)}
                    minDate={new Date()}
                    dateFormat="yyyy-MM-dd"
                  />
                </div>

                <div className="field">
                  <label htmlFor="apptTime">Select Appointment Time *</label>
                  <select
                    name="apptTime"
                    id="apptTime"
                    className="form-select"
                    value={selectedTime}
                    onChange={(e) => setSelectedTime(e.target.value)}
                    required
                  >
                    <option value="">Select Appointment Time *</option>
                    {slotsToRender.map((item) =>
                      item.status === "0" ? (
                        <option
                          value={`${item.start_time} - ${item.end_time}`}
                          key={item.slot_id}
                        >
                          {`${item.start_time} - ${item.end_time}`}
                        </option>
                      ) : null
                    )}
                  </select>
                </div>
              </div>

              <div className="slot-check-row">
                <button
                  className="appointment-btn btn-secondary"
                  type="button"
                  onClick={checkAvailableSlots}
                >
                  Check For Available Slots
                </button>
              </div>

              {/* Patient Details */}
              <div className="patient-details-header">
                <h3 className="section-subtitle">Fill Patient Details Here</h3>
              </div>

              <div className="form-grid">
                <div className="field">
                  <label htmlFor="name">Your Name *</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    id="name"
                    placeholder="Your Name *"
                    value={patientData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="field">
                  <label htmlFor="phone">Your Phone *</label>
                  <input
                    type="tel"
                    name="phone"
                    className="form-control"
                    id="phone"
                    placeholder="Your Phone *"
                    value={patientData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="field">
                  <label htmlFor="email">Your Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    id="email"
                    placeholder="Your Email"
                    value={patientData.email}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="field">
                  <label htmlFor="age">Select Age *</label>
                  <select
                    name="age"
                    id="age"
                    className="form-select"
                    value={patientData.age}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Age *</option>
                    <option value="Below 18">Below 18</option>
                    <option value="18-40">18-40</option>
                    <option value="40 above">40 above</option>
                  </select>
                </div>

                <div className="field full-width">
                  <label htmlFor="address">Address</label>
                  <textarea
                    className="form-control"
                    name="address"
                    id="address"
                    rows="3"
                    placeholder="Address"
                    value={patientData.address}
                    onChange={handleInputChange}
                  ></textarea>
                </div>

                <div className="field full-width">
                  <label htmlFor="message">Message (Optional)</label>
                  <textarea
                    className="form-control"
                    name="message"
                    id="message"
                    rows="4"
                    placeholder="Message (Optional)"
                    value={patientData.message}
                    onChange={handleInputChange}
                  ></textarea>
                </div>
              </div>

              <div className="form-submit-row">
                <button className="appointment-btn btn-primary" type="submit">
                  Book an Appointment
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Appointment;